import React from 'react';
import ReactDOM from 'react-dom';
import superagent from 'superagent';

import {Form, FormControl, FormGroup, ControlLabel, Button, Col, PageHeader, Panel, Table} from 'react-bootstrap';
import styles from './LoginForm.css';
import { Login, LoggedUserId, LoggedUserJazyk } from '../login/Login';
import InfoMsg  from '../../api/InfoMsg';

import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
 en:{
   h2:"Password change",
   heslo1:"Current password",
   heslo2:"New password",
   heslo3:"New password again",
   button:"Save"
 },
 cs: {
   h2:"Změna hesla",
   heslo1:"Současné heslo",
   heslo2:"Nové heslo",
   heslo3:"Nové heslo znovu",
   button:"Uložit"
 }
});

export class UserDetailHeslo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {errorMessage: '', infoMsgStyle:"info"};
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();

    superagent.post('https://rezervace.copasedeje.cz/servis/_password_change.php').
      send("id="+LoggedUserId()).
      send("heslo1="+ReactDOM.findDOMNode(this.refs.Heslo1Input).value).
      send("heslo2="+ReactDOM.findDOMNode(this.refs.Heslo2Input).value).
      send("heslo3="+ReactDOM.findDOMNode(this.refs.Heslo3Input).value).
      then(res => {
        var myObject = JSON.parse(res.text);
        if (myObject.error == '') {
          this.setState({infoMsgStyle: 'info'});
          if (LoggedUserJazyk() == 'cs') {
            this.setState({errorMessage: myObject.msg});
          } else {
            this.setState({errorMessage: myObject.msg_en});
          }
        } else {
          this.setState({infoMsgStyle: 'danger'});
          if (LoggedUserJazyk() == 'cs') {
            this.setState({errorMessage: myObject.error});
          } else {
            this.setState({errorMessage: myObject.error_en});
          }
        }
      });

    return false;
  }

  handleChange(value) {
    this.setState({errorMessage: ''});
  }

  render() {
    strings.setLanguage(LoggedUserJazyk());
    return (
      <div>
        <h2 className={styles.uvodH2}><i className={"fa fa-key " + styles.panelHeaderFa}></i> {strings.h2}</h2>
        <Panel id="uvod_ubytovani" header="" className={styles.panelHome + " card"}>
          <InfoMsg styleBS={this.state.infoMsgStyle} text={this.state.errorMessage}/>
          <Form horizontal className={styles.form} onSubmit={this.handleSubmit} id="form_registrace">
            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>{strings.heslo1}:</Col>
              <Col sm={5}><FormControl type="password" placeholder={strings.heslo1} ref="Heslo1Input" name="Heslo1Input" onChange={this.handleChange} required /></Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>{strings.heslo2}:</Col>
              <Col sm={5}><FormControl type="password" placeholder={strings.heslo2} ref="Heslo2Input" name="Heslo2Input" onChange={this.handleChange} required /></Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>{strings.heslo3}:</Col>
              <Col sm={5}><FormControl type="password" placeholder={strings.heslo3} ref="Heslo3Input" name="Heslo3Input" onChange={this.handleChange} required /></Col>
            </FormGroup>
            <FormGroup>
              <Col sm={3}></Col>
              <Col sm={9}><Button bsStyle="success" type="submit" >{strings.button}</Button></Col>
            </FormGroup>
          </Form>
        </Panel>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// src/components/login/UserDetailHeslo.jsx